import { CometChatCalls } from '@cometchat/calls-sdk-javascript';
import { COMETCHAT_CONSTANTS } from '../AppConstants';

const DOMAIN = COMETCHAT_CONSTANTS.IS_STAGING
  ? 'cometchat-staging.com'
  : 'cometchat.io';

// CometChatUIKit.login() internally re-inits CometChatCalls with only
// appId/region, wiping any custom hosts. Call this again after UIKit login
// (and before CometChatCalls.login) to restore them.
export const initCallsSDK = () => {
  const authKey =
    COMETCHAT_CONSTANTS.AUTH_KEY || localStorage.getItem('authKey') || '';

  return CometChatCalls.init({
    appId: COMETCHAT_CONSTANTS.APP_ID,
    region: COMETCHAT_CONSTANTS.REGION,
    authKey: authKey,
    adminHost: `https://${COMETCHAT_CONSTANTS.APP_ID}.api-${COMETCHAT_CONSTANTS.REGION}.${DOMAIN}/v3.0`,
    clientHost: `https://${COMETCHAT_CONSTANTS.APP_ID}.apiclient-${COMETCHAT_CONSTANTS.REGION}.${DOMAIN}/v3.0`,
    host: `https://${COMETCHAT_CONSTANTS.APP_ID}.call-${COMETCHAT_CONSTANTS.REGION}.${DOMAIN}/v3.0`,
  });
};
